// Third party import
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getToLocalStorage, setToLocalStorage } from "../../Library/Utils";

import {
  IReviewList,
  IReviewUserList,
  ISelectedDivision} from "../../types/review";

interface ReviewState {
  selectedMonth: string;
  selectedYear: string;
  selectedDivision: ISelectedDivision | null;
  selectedDivisionHead: string;
  reviewSettingUsers: IReviewUserList;
  reviewList: IReviewList;
}

const currentDate = new Date();

const localCurrentMonth: string = getToLocalStorage("reviewMonth")
  ? getToLocalStorage("reviewMonth").toString()
  : "";

const currentDefaultMonth: string =
  currentDate.getMonth() === 0 ? "12" : currentDate.getMonth()?.toString();

const currentMonth: string = localCurrentMonth || currentDefaultMonth;

const localCurrentYear = getToLocalStorage("reviewYear")
  ? getToLocalStorage("reviewYear").toString()
  : "";

const currentDefaultYear: string =
  currentMonth === "0"
    ? (currentDate.getFullYear() - 1).toString()
    : currentDate.getFullYear()?.toString();

const currentYear: string = localCurrentYear || currentDefaultYear;
// const selectedDivisionLocal = {
//   selectedDivisionId: getToLocalStorage("selectedDivisionId"),
//   selectedDivisionCompanyId: getToLocalStorage("selectedDivisionCompanyId"),
// };

const initialState: ReviewState = {
  selectedMonth: currentMonth,
  selectedYear: currentYear,
  selectedDivision: null,
  selectedDivisionHead: "",
  reviewSettingUsers: getToLocalStorage("reviewSettingsUser") || [],
  reviewList: getToLocalStorage("reviewList") || []};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    setSelectedReviewMonth: (
      state: { selectedMonth: string },
      action: PayloadAction<string>
    ) => {
      state.selectedMonth = action.payload;
    },
    setSelectedReviewYear: (
      state: { selectedYear: string },
      action: PayloadAction<string>
    ) => {
      state.selectedYear = action.payload;
    },
    setSelectedReviewDivision: (
      state: ReviewState,
      action: PayloadAction<ISelectedDivision | null>
    ) => {
      state.selectedDivision = action.payload;
    },
    setSelectedDivisionHead: (
      state: ReviewState,
      action: PayloadAction<string>
    ) => {
      state.selectedDivisionHead = action.payload;
    },
    setReviewSettingUsers: (
      state: { reviewSettingUsers: IReviewUserList },
      action: PayloadAction<IReviewUserList>
    ) => {
      state.reviewSettingUsers = action.payload;
      setToLocalStorage("reviewSettingsUser", JSON.stringify(action.payload));
    },
    setReviewList: (
      state: { reviewList: IReviewList },
      action: PayloadAction<IReviewList>
    ) => {
      state.reviewList = action.payload;
      setToLocalStorage("reviewList", JSON.stringify(action.payload));
    },
    resetSelectedReviewMonth: (state: { selectedMonth: string }) => {
      state.selectedMonth = currentMonth;
    }}});

export const {
  setSelectedReviewMonth,
  setSelectedReviewYear,
  setSelectedReviewDivision,
  setSelectedDivisionHead,
  setReviewSettingUsers,
  setReviewList,
  resetSelectedReviewMonth} = reviewSlice.actions;

export default reviewSlice.reducer;
